/**
 * BILA ADVs SCRIPTS
 */

jQuery(document).ready(function ($) {
  ("use strict");
  // Function to fetch active text ads via WordPress AJAX
  function fetchActiveTextAds() {
    $.ajax({
      url: ads_ajax.ajax_url,  // Dynamic URL from WordPress
      method: "POST",
      data: {
        action: "get_active_text_ads",
      },
      success: function (response) {
        if (response.success && response.data.length > 0) {
          setupCarousel(response.data);
        }
      },
      error: function () {
        console.log("Failed to fetch advertisements");
      },
    });
  }

  // Function to setup carousel with all messages
  function setupCarousel(ads) {
    var $headerLeft = $(".header-top-left");

    if ($headerLeft.length === 0) return;

    // Get the original message
    var $originalMessage = $(".header-top-message", $headerLeft).first();
    var originalHtml = $originalMessage.html();

    // Clear the container
    $headerLeft.empty();

    // Create array of all messages (original + valid ads)
    var messages = [];

    // Add original message first
    messages.push({
      type: "original",
      content: originalHtml,
    });

    // Add advertisement messages
    ads.forEach(function (ad) {
      messages.push({
        type: "ad",
        content: ad.content,
      });
    });

    // Only proceed if we have more than just the original message
    if (messages.length <= 1) {
      // Restore original message if no ads
      $headerLeft.html($originalMessage);
      return;
    }

    // Create carousel items
    messages.forEach(function (message, index) {
      var $messageDiv = $("<div>", {
        class: "header-top-message",
        "data-index": index,
        css: {
          display: index === 0 ? "block" : "none",
        },
      });

      // Set content directly
      $messageDiv.html(message.content);

      $headerLeft.append($messageDiv);
    });

    // Start carousel rotation
    startCarousel(messages.length);
  }

  // Function to handle carousel rotation
  function startCarousel(messageCount) {
    var currentIndex = 0;

    function rotateMessage() {
      var nextIndex = (currentIndex + 1) % messageCount;

      // Fade out current message
      $('.header-top-message[data-index="' + currentIndex + '"]').fadeOut(
        300,
        function () {
          // Fade in next message
          $('.header-top-message[data-index="' + nextIndex + '"]').fadeIn(500);
          currentIndex = nextIndex;
        },
      );
    }

    // Rotate every 5 seconds
    setInterval(rotateMessage, 5000);
  }

  // Add CSS for smooth transitions
  var styles = `
        .header-top-left {
            position: relative;
            min-height: 30px;
        }
        .header-top-message {
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            transition: opacity 0.3s ease;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            padding: 0 10px;
            box-sizing: border-box;
        }
        .header-top-message a {
            color: inherit;
            text-decoration: none;
        }
        .header-top-message a:hover {
            text-decoration: underline;
        }
        .header-top-message p {
            margin: 0;
            display: inline;
        }
        @media (max-width: 768px) {
            .header-top-message {
                position: relative;
                white-space: normal;
                padding: 5px 10px;
            }
            .header-top-left {
                min-height: auto;
            }
        }
    `;

  var styleSheet = document.createElement("style");
  styleSheet.textContent = styles;
  document.head.appendChild(styleSheet);

  // Start the process
  fetchActiveTextAds();

});
